import moment from "moment";

export function getUrlExtension( url ){
    if(!url || typeof url !== "string" || !url.split(/[#?]/).length || !url.split(/[#?]/)[0] ||
        !url.split(/[#?]/)[0].split('.') || !url.split(/[#?]/)[0].split('.').pop()){
        return ""
    }
    return url.split(/[#?]/)[0].split('.').pop().trim();
}

export function boardMatchesSearch(board, search,filters= {}){
    if(filters["layer"] && filters["layer"].length){
        if(!board.fields["layer"] && filters["layer"].includes("undefined")){
        } else if(!board.fields["layer"] || !filters["layer"].includes(board.fields["layer"])){
            return false
        }
    }
    if(filters["status"] && filters["status"].length){
        if(!board["status"] && filters["status"].includes("undefined")){
        } else if(!board["status"] || !filters["status"].includes(board["status"])){
            return false
        }
    }
    if(filters["vendor"] && filters["vendor"].length){
        if(!board.fields["vendor"] || !filters["vendor"].includes(board.fields["vendor"])){
            return false
        }
    }
    if(filters["market"] && filters["market"].length){
        if(!board.fields["market"] || !filters["market"].includes(board.fields["market"])){
            return false
        }
    }
    if(filters["media format"] && filters["media format"].length){
        if(!board.fields["media format"] || !filters["media format"].includes(board.fields["media format"])){
            return false
        }
    }
    if (!search || search.length < 3){
        return true
    }
    search = search.toLowerCase();
    if(board.fields["media format"] && board.fields["media format"].toLowerCase().includes(search)){
        return true
    }
    if(board.fields["unit #"] && ("" + board.fields["unit #"]).toLowerCase().includes(search)){
        return true
    }
    if(board.fields["description"] && board.fields["description"].toLowerCase().includes(search)){
        return true
    }
    if(board.fields["vendor"] && (""+board.fields["vendor"]).toLowerCase().includes(search)){
        return true
    }
    if(board.fields["market"] && (""+board.fields["market"]).toLowerCase().includes(search)){
        return true
    }
    if(search.includes("not favorite")){
        if( !board.favorite){
            return true
        }
        return false
    }
    if(search.includes("favorite") && board.favorite){
        return true
    }
    return false
}

export function GetSelectedBoards(boards,search){
    let selectedBoards = {};
    for(let key in boards){
        if(boards[key].selected && boardMatchesSearch(boards[key],search)){
            selectedBoards[key] = boards[key];
        }
    }
    return selectedBoards
}

/* 
group array items by given criteria
the result type is: { [group_name: string]: item[] } 
*/
export function GroupByProperty(items, callbackFn) {
    return items.reduce((acc, obj) => {
        const key = callbackFn(obj);

        if (!acc[key]) {
            acc[key] = [obj];
        } else {
            acc[key] = [...acc[key], obj];
        }

        return acc;
    }, {});
}

export function GetBoardsGroupedByUnit(campaign) {
    console.log("GetBoardsGroupedByUnit")
    try {
        let result = {};
        if (Object.keys(campaign.boards).length) {
            // group boards by the first part of unit #
            const groupedObj = GroupByProperty(Object.values(campaign.boards), ({ fields }) => (""+fields["unit #"]).split('.')[0]);
            for (const group in groupedObj) {
                let items = groupedObj[group];
                if (items.length > 1) {
                    // get board that does not have '.n' in its unit #
                    const parentItem = items.splice(items.findIndex(({ fields }) =>  (""+fields["unit #"]).split('.').length < 2), 1)[0];
                    items.sort((a, b) => (""+ a.fields["unit #"]).split('.')[1] -  (""+b.fields["unit #"]).split('.')[1]);
                    // convert to the original data format and set boards with the same base unit # to 'childBoards' property
                    result[parentItem.vendorId] = {
                        ...parentItem,
                        childBoards: items,
                    };
                } else {
                    result[items[0].vendorId] = {
                        ...items[0],
                    };
                }
            }
        }
        return result;
    } catch (err) {
        console.error(err)
        return campaign.boards;
    }
}

export function GetSortedVendorIds(campaign){
    var sortedVendorIds = [];
    // if(Object.keys(campaign.boards).length && campaign.boards[Object.keys(campaign.boards)[0]].index !== undefined){
    //     for (var vendorId in campaign.boards) {
    //         sortedVendorIds.push({vendorId: vendorId, index: campaign.boards[vendorId].index});
    //     }
    //     sortedVendorIds.sort(function(a, b) {
    //         return a.index - b.index ;
    //     });
    // }else{
    for (var vendorId in campaign.boards) {
        sortedVendorIds.push({vendorId: vendorId, "unit #": ""+campaign.boards[vendorId].fields["unit #"]});
    }
    sortedVendorIds.sort(function(a, b) {
        const unitA = a["unit #"];
        const unitB = b["unit #"];

        // Check if both values are numeric (even if they're provided as strings)
        if (!isNaN(unitA) && !isNaN(unitB)) {
            // Compare as numbers
            return Number(unitA) - Number(unitB);
        } else {
            // At least one is a string, so compare alphabetically
            return ("" + unitA).localeCompare("" + unitB);
        }
    });
    // }
    return sortedVendorIds
}

export function CalcOverride(board){
    let baseDays = moment(board.fields["end date"]).diff(moment(board.fields["start date"]), 'days');
    let mediaCost = baseDays * (board.fields["neg rate"]/28);
    if(!["completed","posted"].includes(board.status)){
        return {
            overridePercent:"",
            bonusImpressions: 0,
            overrideMediaValue: 0,
            baseDays:baseDays,
            extraDays: 0,
            mediaCost: Math.round(mediaCost * 100)/100,
        }
    }
    //get extra days (today - posted)
    let takedown = moment();
    if(board.fields["takedown date"]){
        takedown = moment(board.fields["takedown date"]);
    }
    let totalDays = takedown.diff(moment(board.fields["install date"]), 'days');
    if (totalDays < 0 || totalDays < baseDays){
        return {
            baseDays:baseDays,
            extraDays: 0,
            overridePercent:"",
            bonusImpressions: 0,
            overrideMediaValue: 0,
            mediaCost: Math.round(mediaCost * 100)/100,
        }
    }
    let extraDays = totalDays - baseDays;
    let overridePercent = extraDays/baseDays;
    let bonusImpressions = extraDays * (board.fields["4-wk imp"]/28);//extra days * daily impressions
    let overrideMediaValue = extraDays * (board.fields["neg rate"]/28);//extra days * daily cost
    return {
        baseDays:baseDays,
        extraDays: extraDays,
        overridePercent: Math.round(overridePercent * 1000)/10+"%",
        bonusImpressions: Math.round(bonusImpressions),
        overrideMediaValue: Math.round(overrideMediaValue),
        mediaCost: Math.round(mediaCost * 100)/100,
    }
}

export function ActivityTracker(boards){
    let confirmed = 0;
    let posted = 0;
    let totalCost = 0;
    let overrideValue = 0;
    for (let boardId in boards){
        let board = boards[boardId]
        let o = CalcOverride(board);
        switch (board.status){
            case "confirmed":
                confirmed++;
                break;
            case "posted":
                confirmed++;
                posted++;
                totalCost += o.mediaCost;
                overrideValue += o.overrideMediaValue;
                break;
            case "completed":
                posted++;
                confirmed++;
                totalCost += o.mediaCost;
                overrideValue += o.overrideMediaValue;
                break;
        }
    }
    return {
        posted:posted,
        confirmed: confirmed,
        postedPercent: Math.round(posted/confirmed * 1000)/10,
        override: Math.round(overrideValue/totalCost * 1000)/10,
    }
}

export function GetStatusCounts(boards){
    let statuses = {};
    for (let boardId in boards) {
        let board = boards[boardId]
        if(statuses[board.status]){
            statuses[board.status]++;
        }else{
            statuses[board.status] = 1;
        }
    }
    return statuses;
}

export function GetLayerCounts(boards){
    let layers = {};
    for (let boardId in boards) {
        let board = boards[boardId]
        if(layers[board.fields["layer"]]){
            layers[board.fields["layer"]]++;
        }else{
            layers[board.fields["layer"]] = 1;
        }
    }
    return layers;
}

export function GetFormatCounts(boards){
    let formats = {};
    for (let boardId in boards) {
        let board = boards[boardId]
        if(formats[board.fields["media format"]]){
            formats[board.fields["media format"]]++;
        }else{
            formats[board.fields["media format"]] = 1;
        }
    }
    return formats;
}

export function GetVendorCounts(boards){
    let formats = {};
    for (let boardId in boards) {
        let board = boards[boardId]
        if(formats[board.fields["vendor"]]){
            formats[board.fields["vendor"]]++;
        }else{
            formats[board.fields["vendor"]] = 1;
        }
    }
    return formats;
}

export function GetMarketCounts(boards){
    let formats = {};
    for (let boardId in boards) {
        let board = boards[boardId]
        if(formats[board.fields["market"]]){
            formats[board.fields["market"]]++;
        }else{
            formats[board.fields["market"]] = 1;
        }
    }
    return formats;
}

/**
* Search params are held as an array of two elements arrays where member 0 is the key and member 1 is value
* This function converts params to the format that we use to store filters in state
*/
export function parseExistingParams(searchParams) {
    const entries = Array.from(searchParams.entries());
    return entries.reduce((acc, a) => ((acc[a[0]] = acc[a[0]] || []).push(a[1]), acc), {});
}

/**
* Converts object with filters selected to URLSearchParams format
*/
export function convertStateToParams(filters) {
    const searchParams = [];
    
    for (const key in filters) {
        if (Array.isArray(filters[key])) {
            for (const value of filters[key]) {
                searchParams.push([key, value]);
            }
        } else {
            searchParams.push([key, filters[key]]);
        }
    }

    return searchParams;
}

export function updateFilters(filters, key, value) {
    if (filters[key].includes(value)) {
        filters[key].splice(filters[key].indexOf(value), 1);
    } else {
        filters[key].push(value);
    }

    return filters;
}
export function IsEmailValid(email) {
    if (!email?.trim()) {
        return false;
    }

    const regex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]+$/g);
    return regex.test(email);
}

export function IsUserOwner(user, campaign) {
    if (!user || !campaign) {
        return false;
    }

    return user._id === campaign.owner ||
        campaign.otherOwners?.some(owner => owner._id === user._id);
}

export function IsUserPrimaryOwner(user, campaign) {
    if (!user || !campaign) {
        return false;
    }

    return user._id === campaign.owner;
}
